import { PlayerEventType, PlayerEventStateType, PlayBackState } from '../model/playerEventModel';
import { resetSessionTimer, clearSessionTimer } from './sessionUtil';

const shouldResetSeesionTimer = (event) => {
    const { stateType, state, eventType } = event;

    if (eventType === PlayerEventType.StartSession) {
        return true;
    }

    let needResetTimer = false;
    if (stateType) {
        switch (stateType) {
        case PlayerEventStateType.ContentPage:
        case PlayerEventStateType.Zoom:
        case PlayerEventStateType.Search:
        case PlayerEventStateType.Screen:
        case PlayerEventStateType.Viewport:
        case PlayerEventStateType.Volume:
            needResetTimer = true; break;
        case PlayerEventStateType.PlayBack:
            if (state) {
                switch (state) {
                case PlayBackState.Loaded:
                case PlayBackState.Paused:
                case PlayBackState.Ended:
                    needResetTimer = true; break;
                default: needResetTimer = false;
                }
            }

            break;

        default: needResetTimer = false;
        }
    }

    return needResetTimer;
};

const sholudClearSeesionTimer = (event) => {
    const { eventType, stateType, state } = event;
    return eventType === PlayerEventType.EndSession
        || (stateType === PlayerEventStateType.PlayBack && state === PlayBackState.Playing);
};

const handleSessionTimer = (event, args) => {
    // when the link has expired, we do not need any session action
    if (args.isExpired) {
        return;
    }

    if (shouldResetSeesionTimer(event)) {
        resetSessionTimer();
    }

    if (sholudClearSeesionTimer(event)) {
        clearSessionTimer();
    }
};

export default handleSessionTimer;
